import { useContext, useState } from "react"
import shortid from "shortid"
import { AuthContext } from "../../../contexts/Auth/AuthContext"
import { NotificationContext } from "../../../contexts/NotificationCTX/NotificationContext"
import { api } from "../../../helpers"
import { Button, IconGoogle, Link } from "../../atoms"
import { Dialog } from "../Dialog"
import {
  DetailsTable,
  EmptyTable,
  EmptyTableWrapper,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  Wrapper
} from "./styles"

export interface RowContract {
  [key: string]: any | Object
}

type TableProps = {
  data: RowContract[]
  onClick: (data: RowContract[]) => void
}

export function TableEmployee({ data, onClick }: TableProps) {
  const { applicationData } = useContext(AuthContext)
  const [openDialog, setOpenDialog] = useState(false)
  const [idExclusao, setIdExclusao] = useState<number | null>(null)

  const {
    setType,
    setShow,
    setText: setTextAlert
  } = useContext(NotificationContext)

  const excluir = async (id: number) => {
    const response = await api.delete(`/api/funcionario/7/${id}`)
    if (response.data.statuscode === 200) {
      data = data.filter((item) => {
        return item.Codigo !== id
      })
      setType("success")
      setTextAlert(response.data.message)
      setShow(true)
      onClick(data)
    }
  }

  const tableHead =
    Object.keys(data).length > 0 ? [...Object.keys(data[0]), "Ação"] : []

  const tableBody =
    Object.keys(data).length > 0
      ? data.map((row, index) => {
          const newRow = []
          for (const key in row) {
            if (tableHead.includes(key))
              newRow.push(
                <TableCell key={shortid.generate()}>{row[key]}</TableCell>
              )
          }
          newRow.push(
            <TableCell width={10} key={shortid.generate()}>
              <Link to={"/cadastros/funcionarios/" + row["Codigo"]}>
                Editar
              </Link>
            </TableCell>
          )
          newRow.push(
            <TableCell width={10} key={shortid.generate()}>
              <Link to={"/cadastros/funcionarios/direitos/" + row["Codigo"]}>
                Direitos
              </Link>
            </TableCell>
          )
          newRow.push(
            <TableCell width={10} key={shortid.generate()}>
              <Button
                appearance="danger"
                onClick={() => {
                  setOpenDialog(true)
                  setIdExclusao(row["Codigo"])
                }}
              >
                Excluir
              </Button>
            </TableCell>
          )
          return newRow
        })
      : [[]]

  return (
    <>
      {Object.keys(data).length > 0 ? (
        <Wrapper>
          <DetailsTable className="table table-striped">
            <TableHeader>
              <TableRow>
                {tableHead.map((columnName) => (
                  <TableColumn key={shortid.generate()}>
                    {columnName}
                  </TableColumn>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {tableBody.map((row) => (
                <TableRow key={shortid.generate()}>
                  {row.map((tCell) => tCell)}
                </TableRow>
              ))}
            </TableBody>
          </DetailsTable>
        </Wrapper>
      ) : (
        <EmptyTableWrapper>
          <EmptyTable>
            <IconGoogle>error_outline</IconGoogle> Não encontramos nenhum
            registro para apresentação.
          </EmptyTable>
        </EmptyTableWrapper>
      )}
      <Dialog
        open={openDialog}
        title="Confirmação de exclusão"
        description="Confirma exclusão do registro?"
        onShow={(action) => {
          setOpenDialog(action === "opened")
        }}
        actions={
          <>
            <Button
              appearance="success"
              autoFocus
              onClick={(e) => {
                excluir(idExclusao!)
                setOpenDialog(false)
              }}
            >
              Confirmar
            </Button>
          </>
        }
      />
    </>
  )
}
